export const ROLE_LABEL = {
    super_admin: 'Super Admin',
    platform_admin: 'Admin platformă',
    restaurant_admin: 'Administrator restaurant',
    manager: 'Manager',
    waiter: 'Ospătar',
    kitchen: 'Bucătărie',
};

export function roleLabel(role) {
    if (!role) return '—';
    return ROLE_LABEL[role] || role.replace(/_/g, ' ');
}
